// 停止运营配置：修改这里即可调整停关日期 / 落款
export const SHUTDOWN_AT = new Date("2026-11-25T23:59:59+08:00");
export const SHUTDOWN_DATE_TEXT = "2026年11月25日";
export const NOTICE_DATE_TEXT = "2026年10月26日";
export const NOTICE_SIGNATURE = "Togo导航团队";

// 是否已停关
export function isShutdown(now = new Date()) {
  return now.getTime() > SHUTDOWN_AT.getTime();
}

// 距离停关剩余天数（向下取整，最小 0）
export function daysUntilShutdown(now = new Date()) {
  const ms = SHUTDOWN_AT.getTime() - now.getTime();
  return Math.max(0, Math.floor(ms / 86400000));
}

// 充值 / 提取账号关闭提示
export function rechargeClosedMessage() {
  return isShutdown()
    ? `Togo导航已于${SHUTDOWN_DATE_TEXT}停止运营，如有退款需求请联系客服。`
    : `因公司业务调整，Togo导航将于${SHUTDOWN_DATE_TEXT}停止运营，充值及提取账号功能已关闭。流量未使用完的用户，请联系客服折算申请退款。`;
}
